import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://hollyzolly.shop";
const DEFAULT_TITLE = "Holly Zolly | Authentic Vastu Products, Yantras & Consultation";
const DEFAULT_DESCRIPTION =
  "Holly Zolly brings authentic Vastu products, sacred yantras, and expert Vastu consultation to help create harmony, prosperity, and positive energy in your home and workspace.";
const DEFAULT_IMAGE = `${SITE_URL}/image/logo/LOGO.png`;

const updateMeta = (attrName, attrValue, content) => {
  if (!content) return;
  const selector = `meta[${attrName}='${attrValue}']`;
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attrName, attrValue);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
};

const updateLink = (rel, href) => {
  if (!href) return;
  let element = document.head.querySelector(`link[rel='${rel}']`);
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
};

export default function SEO({
  title,
  description,
  image,
  type = "website",
  url,
  schema,
}) {
  const location = useLocation();
  const pageUrl = url || `${SITE_URL}${location.pathname}`;

  useEffect(() => {
    document.title = title ? `${title}` : DEFAULT_TITLE;
    updateMeta("name", "description", description || DEFAULT_DESCRIPTION);
    updateMeta("property", "og:title", title || DEFAULT_TITLE);
    updateMeta("property", "og:description", description || DEFAULT_DESCRIPTION);
    updateMeta("property", "og:image", image || DEFAULT_IMAGE);
    updateMeta("property", "og:type", type);
    updateMeta("property", "og:url", pageUrl);
    updateMeta("name", "twitter:card", "summary_large_image");
    updateMeta("name", "twitter:title", title || DEFAULT_TITLE);
    updateMeta("name", "twitter:description", description || DEFAULT_DESCRIPTION);
    updateMeta("name", "twitter:image", image || DEFAULT_IMAGE);
    updateLink("canonical", pageUrl);
  }, [title, description, image, type, pageUrl]);

  return (
    <>
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema, null, 2)}
        </script>
      )}
    </>
  );
}
